export const LinkCastModal: string = 'LinkCastModal';
